import { BucketDef } from './bucket-def';
import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';
import { BucketDate } from './bucket-date';
import * as moment from 'moment';

export class BucketedBucketing extends BaseBucketingStrategy implements BucketingStrategy {
    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs(): void {
        this.bucketDefs.push(new BucketDef(this.today));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'days'), this.startOfNextBucket()));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(2, 'days'), this.startOfNextBucket()));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'week'), this.startOfNextBucket(), true, '1W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(2, 'week'), this.startOfNextBucket(), true, '2W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(3, 'week'), this.startOfNextBucket(), true, '3W'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 1, true), this.startOfNextBucket(), true, '1M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 2, true), this.startOfNextBucket(), true, '2M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 3, true), this.startOfNextBucket(), true, '3M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 4, true), this.startOfNextBucket(), true, '4M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 5, true), this.startOfNextBucket(), true, '5M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
    }

     strategyName(): string {
         return 'Bucketed';
     }
}
